import { FormModel } from "../../../utils/FormModel";
import { ObjectId } from "../../../helpers/objectid";

export class User extends FormModel {
    
    
    public id: string = "";
    public name: string = "";
    public email: string = "";
    public role: string = "User";
    public auth0Id: string = "";

    /**
     * Kept for compatibility with API builds that still return only a single
     * company. Prefer companyIds / getCompanyIds().
     */
    public companyId: string = "";

    public companyIds: string[] = [];

    public isAdmin() {
       return UserRole[this.role] == UserRole.PortalAdmin;
    }

    /**
     * The user's companies, tolerating an older API that only sends companyId.
     */
    public getCompanyIds(): string[] {
        if (this.companyIds && this.companyIds.length) return this.companyIds;
        if (this.companyId && !ObjectId.isDefault(this.companyId)) return [this.companyId];
        return [];
    }

    public belongsToManyCompanies(): boolean {
        return this.getCompanyIds().length > 1;
    }
}

export enum UserRole {
    User = "User",
    PortalAdmin = "PortalAdmin",
    CompanyAdmin = "CompanyAdmin"
}

export const UserRoleRender: Record<UserRole, string> = {
    "User": "User",
    "PortalAdmin": "Portal Admin",
    "CompanyAdmin": "Company Admin"
}